import React from 'react'
//Components
import { SpinnerEllipsis } from './Spinners'

const PageLoader = () => {
    return (
        <div className="page-loader">
            <SpinnerEllipsis />
        </div>
    )
}

export default PageLoader
